(() => {
  if (window.__deferredSectionVideosInitialized) return;
  window.__deferredSectionVideosInitialized = true;
  const mobileQuery = "(max-width: 767px)";
  const isMobileViewport = () => window.matchMedia && window.matchMedia(mobileQuery).matches;

  const hydrateVideo = (video) => {
    if (!video) return false;

    const source = video.querySelector("source[data-video-src]");
    if (!source) return false;

    const deferredSrc = source.getAttribute("data-video-src");
    if (!deferredSrc) return false;

    source.setAttribute("src", deferredSrc);
    source.removeAttribute("data-video-src");
    video.load();
    return true;
  };

  const playVideo = (video) => {
    if (!video) return;
    hydrateVideo(video);
    video.setAttribute("autoplay", "");

    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch(() => {});
    }
  };

  const pauseVideo = (video) => {
    if (!video) return;
    video.pause();
    video.removeAttribute("autoplay");
  };

  const bindStickyImagesAndText = (section) => {
    if (section.dataset.deferredVideosBound === "true") return;
    section.dataset.deferredVideosBound = "true";

    const slides = section.querySelectorAll("[data-sticky-image]");
    if (!slides.length) return;

    let sectionIsVisible = false;

    const syncActiveVideo = () => {
      if (!sectionIsVisible) return;

      let activeSlide = slides[0];
      slides.forEach((slide) => {
        if (slide.classList.contains("is-active")) activeSlide = slide;
      });

      slides.forEach((slide) => {
        const video = slide.querySelector("video[data-sticky-video]");
        if (!video) return;

        if (slide === activeSlide) {
          playVideo(video);
        } else {
          pauseVideo(video);
        }
      });
    };

    const classObserver = new MutationObserver(syncActiveVideo);
    slides.forEach((slide) => {
      classObserver.observe(slide, { attributes: true, attributeFilter: ["class"] });
    });

    const sectionObserver = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        sectionIsVisible = Boolean(entry && entry.isIntersecting);

        if (sectionIsVisible) {
          syncActiveVideo();
          return;
        }

        slides.forEach((slide) => {
          pauseVideo(slide.querySelector("video[data-sticky-video]"));
        });
      },
      { threshold: 0.1 },
    );

    sectionObserver.observe(section);

    section.addEventListener("click", (event) => {
      if (!isMobileViewport()) return;

      const slide = event.target.closest("[data-sticky-image]");
      if (!slide) return;

      const selectedVideo = slide.querySelector("video[data-sticky-video]");
      if (!selectedVideo) return;

      slides.forEach((currentSlide) => {
        const currentVideo = currentSlide.querySelector("video[data-sticky-video]");
        if (!currentVideo) return;

        if (currentVideo === selectedVideo) {
          playVideo(currentVideo);
        } else {
          pauseVideo(currentVideo);
        }
      });
    });
  };

  const bindStickyImageCards = (root) => {
    if (root.dataset.deferredVideosBound === "true") return;
    root.dataset.deferredVideosBound = "true";

    const wrappers = root.querySelectorAll("[data-sticky-card-wrapper]");
    if (!wrappers.length) return;

    if (isMobileViewport()) {
      root.addEventListener("click", (event) => {
        const wrapper = event.target.closest("[data-sticky-card-wrapper]");
        if (!wrapper) return;

        const selectedVideo = wrapper.querySelector("video[data-sticky-card-video]");
        if (!selectedVideo) return;

        wrappers.forEach((currentWrapper) => {
          const currentVideo = currentWrapper.querySelector("video[data-sticky-card-video]");
          if (!currentVideo) return;

          if (currentVideo === selectedVideo) {
            playVideo(currentVideo);
          } else {
            pauseVideo(currentVideo);
          }
        });
      });
      return;
    }

    const wrapperObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target.querySelector("video[data-sticky-card-video]");
          if (!video) return;

          if (entry.isIntersecting) {
            playVideo(video);
          } else {
            pauseVideo(video);
          }
        });
      },
      { threshold: 0.35, rootMargin: "120px 0px 120px 0px" },
    );

    wrappers.forEach((wrapper) => {
      if (wrapper.querySelector("video[data-sticky-card-video]")) {
        wrapperObserver.observe(wrapper);
      }
    });
  };

  const bindBackgroundVideo = (video) => {
    if (!video || video.dataset.deferredVideoBound === "true") return;
    video.dataset.deferredVideoBound = "true";

    if (isMobileViewport()) {
      pauseVideo(video);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (!entry) return;

        if (entry.isIntersecting) {
          playVideo(video);
          observer.disconnect();
        }
      },
      { threshold: 0.1, rootMargin: "200px 0px 200px 0px" },
    );

    observer.observe(video);
  };

  const initBackgroundVideos = () => {
    document.querySelectorAll("video[data-deferred-bg-video]").forEach(bindBackgroundVideo);
  };

  const init = () => {
    document.querySelectorAll("sticky-images-and-text").forEach(bindStickyImagesAndText);
    document.querySelectorAll("sticky-image-cards").forEach(bindStickyImageCards);
    initBackgroundVideos();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);

  const observer = new MutationObserver((entries) => {
    entries.forEach((entry) => {
      entry.addedNodes.forEach((node) => {
        if (!node || node.nodeType !== 1) return;

        if (node.matches && node.matches("video[data-deferred-bg-video]")) {
          bindBackgroundVideo(node);
        }

        if (node.querySelectorAll) {
          node.querySelectorAll("video[data-deferred-bg-video]").forEach(bindBackgroundVideo);
        }
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
